<template>
  <div>
    <div class="row no-gutters">
      <div v-for="item in valoraciones" :key="item.id" class="form-group col-12 pl-2 pr-2">
        <label class="mb-0">{{ item.nombre }}</label>
        <textarea v-model="item.detalle" class="form-control form-control-sm" rows="5"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import valoracionService from "@/services/valoracionServcice";
import valoracionHistoriaService from "@/services/valoracionHistoriaService";
import Swal from "sweetalert2";
import Toast from "@/components/common/utilities/toast";
import {isEmpty} from "lodash";

export default {
  props : ['idHistoria', 'idTipoHistoria', 'usuario','codigo','edad'],
  data(){
    return {
      valoraciones : []
    }
  },
  methods : {
    async cargarValoraciones(){

      const response = await valoracionService.index(this.codigo);

      this.valoraciones = response.data
        .filter(x => {
          if (x.edadInicio === null || x.edadInicio === undefined || x.edadFin === null || x.edadFin === undefined) {
            return true;
          }
          return this.edad !== undefined && 
                 parseInt(this.edad) >= parseInt(x.edadInicio) && 
                 parseInt(this.edad) <= parseInt(x.edadFin);
        })
        .map(x => {
          return {
            ...x,
            detalle: x.defaultValue || ''
          };
        });
    },
    async save(){
      try{

        const obj = {
          id_historia : this.idHistoria,
          valoraciones : this.valoraciones.filter(x=>x.detalle !== '')
        };

        this.LoaderSpinnerShow();

        await valoracionHistoriaService.store(obj);

        this.LoaderSpinnerHide();

        Toast.fire({
          icon: 'success',
          title: 'Datos guardados con exíto'
        });

      }catch (e) {
        console.log(e);
        this.LoaderSpinnerHide();
        Swal.fire('Ups', 'ha ocurrido un error al procesar la solicitud');
      }


    }
  },
  async created() {
    await this.cargarValoraciones();

    const response = await valoracionHistoriaService.show(this.idHistoria);

    if(!isEmpty(response.data)){
      response.data.forEach(x => {
        let i = this.valoraciones.findIndex(y=> y.id === x.id_valoracion);
        if(i !== -1) this.valoraciones[i].detalle = x.detalle;
      });
    }
  }
}
</script>

<style scoped>

</style>